import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PageAlert } from '@vst/beam';
import { useTranslation } from 'react-i18next';

import { resetSubTypeUpdateStatus, selectNetwork } from '@app/redux';

import { CommandState } from '../../../../../platform/src/server/dataSources/PSM/schemaTypes';

export const SubTypeUpdateStatusAlert = () => {
  const { t } = useTranslation('Network');
  const dispatch = useDispatch();

  const { ontMode, updateStatus } = useSelector(selectNetwork);
  const invalidCommandStatus = ![CommandState.Succeeded, CommandState.Failed].includes(updateStatus as CommandState);

  useEffect(() => {
    return () => {
      dispatch(resetSubTypeUpdateStatus());
    };
  }, []);

  if (!ontMode || invalidCommandStatus) {
    return null;
  }

  const isSuccessful = updateStatus === CommandState.Succeeded;

  const variant = isSuccessful ? 'success' : 'error';

  const title = isSuccessful
    ? t('networkManagement.successfulSwitchAlert.title', { mode: ontMode })
    : t('networkManagement.failedSwitchAlert.title');

  const description = isSuccessful
    ? t('networkManagement.successfulSwitchAlert.description')
    : t('networkManagement.failedSwitchAlert.description');

  return <PageAlert variant={variant} title={title} description={description} style={{ background: 'white' }} />;
};
